"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CURRENT_EMBEDDING_VERSION () {
        return CURRENT_EMBEDDING_VERSION;
    },
    get DocumentEmbeddingInsert () {
        return DocumentEmbeddingInsert;
    },
    get DocumentEmbeddingMetadata () {
        return DocumentEmbeddingMetadata;
    },
    get DocumentEmbeddingModel () {
        return DocumentEmbeddingModel;
    },
    get DocumentEmbeddingSearchResult () {
        return DocumentEmbeddingSearchResult;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const DocumentEmbeddingMetadata = _zod.z.object({
    filename: _zod.z.string(),
    content_type: _zod.z.string().optional(),
    page_range: _zod.z.object({
        start: _zod.z.number(),
        end: _zod.z.number()
    }).optional()
});
const DocumentEmbeddingModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    s3_file_id: _zod.z.instanceof(_bson.ObjectId),
    chunk_index: _zod.z.number(),
    total_chunks: _zod.z.number(),
    content: _zod.z.string(),
    heading_path: _zod.z.array(_zod.z.string()),
    embedding: _zod.z.array(_zod.z.number()),
    token_count: _zod.z.number(),
    metadata: DocumentEmbeddingMetadata,
    created_at: _zod.z.date(),
    updated_at: _zod.z.date(),
    embedding_model: _zod.z.string(),
    embedding_version: _zod.z.string(),
    deleted_at: _zod.z.date().nullable().optional()
});
const DocumentEmbeddingInsert = DocumentEmbeddingModel.omit({
    _id: true
});
const DocumentEmbeddingSearchResult = DocumentEmbeddingModel.extend({
    score: _zod.z.number()
}).omit({
    embedding: true
});
const CURRENT_EMBEDDING_VERSION = "1.0.0";
